import React from "react";
import { motion } from "framer-motion";
import TeamCard from "../components/TeamCard";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRef } from "react";
function Team() {
 const leadershipRef = useRef(null);

const scrollLeft = () => {
  leadershipRef.current.scrollBy({
    left: -350,
    behavior: "smooth"
  });
};

const scrollRight = () => {
  leadershipRef.current.scrollBy({
    left: 350,
    behavior: "smooth"
  });
};

const headsRef = useRef(null);

const scrollHeadsLeft = () => {
  headsRef.current.scrollBy({
    left: -350,
    behavior: "smooth"
  });
};

const scrollHeadsRight = () => {
  headsRef.current.scrollBy({
    left: 350,
    behavior: "smooth"
  });
};
const leadership = [
  
{
id: 1,
images: ["/images/founder.jpeg"],
name: "Niyati Bajaj",
role: "Founder",
description:
"Leading EKYA with a vision of creating meaningful social impact through youth-driven initiatives."
},
{
id: 2,
images: ["/images/co-founder.png"],
name: "Vidita Saini",
role: "Co-Founder",
description:
"She leads strategic initiatives, community programs, and partnerships to drive meaningful social impact."
},
{
id: 3,
images: ["/images/chief.jpg"],
name: "Prithika Bajaj",
role: "Chief Advisor",
description:
"Managing operations and ensuring every initiative creates measurable impact."
}
];

const teamHeads = [
  {
id: 8,
images: [
"/images/deepanshu.jpg",
],
name: "Deepanshu Singh",
role: "Technical Head",
description:
"Leading website development and technical operations."
},
{
  
id: 4,
images: [
"/images/aashni.jpg",
"/images/shayna.jpg"
],
name: "Aashni & Shayna",
role: "Social Media Heads",
description:
"Leading EKYA's digital presence and social media strategy."
},
{
id: 5,
images: [
"/images/yovraj.jpg",
"/images/yuvraj.jpg"
],
name: "Yovraj & Yuvraj",
role: "Operations Heads",
description:
"Overseeing planning and execution of organizational activities."
},
{
id: 6,
images: [
"/images/jeevansh.jpg",
"/images/kashvi.jpg"
],
name: "Jeevansh & Kashvi",
role: "Event Management Heads",
description:
"Leading planning and execution of EKYA events."
},
{
id: 7,
images: [
"/images/freya.jpg",
"/images/aashvi.jpg"
],
name: "Freya & Aashvi",
role: "Volunteer Management Heads",
description:
"Leading volunteer outreach and engagement."
}

];

return ( <div className="bg-[#F8F5F0] min-h-screen">

  <section className="max-w-7xl mx-auto px-6 py-20">

    <motion.div
      initial={{
        opacity: 0,
        y: 40
      }}
      animate={{
        opacity: 1,
        y: 0
      }}
    >

      <h1
        className="
          text-5xl
          md:text-6xl
          font-bold
          text-center
          text-[#2F5D50]
        "
      >
        Meet The Team
      </h1>

      <p
        className="
          text-center
          text-gray-600
          mt-5
          max-w-3xl
          mx-auto
        "
      >
        The passionate individuals working together
        to build positive change through EKYA.
      </p>

    </motion.div>

  </section>

 <section className="max-w-7xl mx-auto px-6 pb-20">

  <div className="flex items-center justify-between mb-10">

    <h2
      className="
        text-4xl
        font-bold
        text-[#4B1D3F]
      "
    >
      Leadership
    </h2>

    <div className="flex gap-3">

      <button
        onClick={scrollLeft}
        className="
          w-12
          h-12
          rounded-full
          bg-white
          shadow-lg
          hover:bg-[#2F5D50]
          hover:text-white
          transition-all
        "
      >
        <FaChevronLeft className="mx-auto" />
      </button>

      <button
        onClick={scrollRight}
        className="
          w-12
          h-12
          rounded-full
          bg-white
          shadow-lg
          hover:bg-[#2F5D50]
          hover:text-white
          transition-all
        "
      >
        <FaChevronRight className="mx-auto" />
      </button>

    </div>

  </div>

  <div
    ref={leadershipRef}
    className="
      flex
      gap-8
      overflow-x-auto
      scrollbar-hide
      pb-4
      scroll-smooth
    "
  >

    {leadership.map((member) => (

      <TeamCard
        key={member.id}
        images={member.images}
        name={member.name}
        role={member.role}
        description={member.description}
      />

    ))}

  </div>

</section>

 <section className="max-w-7xl mx-auto px-6 pb-24">

  <div className="flex items-center justify-between mb-10">

    <h2
      className="
        text-4xl
        font-bold
        text-[#4B1D3F]
      "
    >
      Department Heads
    </h2>

    <div className="flex gap-3">

      <button
        onClick={scrollHeadsLeft}
        className="
          w-12
          h-12
          rounded-full
          bg-white
          shadow-lg
          hover:bg-[#2F5D50]
          hover:text-white
          transition-all
        "
      >
        <FaChevronLeft className="mx-auto" />
      </button>

      <button
        onClick={scrollHeadsRight}
        className="
          w-12
          h-12
          rounded-full
          bg-white
          shadow-lg
          hover:bg-[#2F5D50]
          hover:text-white
          transition-all
        "
      >
        <FaChevronRight className="mx-auto" />
      </button>

    </div>

  </div>

  <div
    ref={headsRef}
    className="
      flex
      gap-8
      overflow-x-auto
      scrollbar-hide
      pb-4
      scroll-smooth
    "
  >

    {teamHeads.map((member) => (

      <TeamCard
        key={member.id}
        images={member.images}
        name={member.name}
        role={member.role}
        description={member.description}
      />

    ))}

  </div>

</section>

</div>


);
}

export default Team;
